import { Text, Modal, toast, useServerResponseTranslation } from 'dash-ui';
import { useTranslation } from 'react-i18next';

import {
  GetBrokerByIdDocument,
  BrokerLicenseStatusesEnum,
  useUpdateBrokerLicenseStatusMutation,
} from 'gql/generated.graphql';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  brokerId: string;
};

export const ActivateBrokerLicenseModal = ({
  isOpen,
  onClose,
  brokerId,
}: Props) => {
  const { t } = useTranslation(['pages', 'common', 'forms']);
  const translateServerResponse = useServerResponseTranslation();

  const [updateBrokerLicenseStatus, { loading }] =
    useUpdateBrokerLicenseStatusMutation({
      refetchQueries: [
        {
          query: GetBrokerByIdDocument,
          variables: {
            brokerId,
          },
        },
      ],
    });

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      title={t(`pages:brokersPage:modals:activateBrokerLicenseTitle`) || ''}
      cancelButton={{ title: t('common:labels.cancel'), onClick: onClose }}
      submitButton={{
        title: t('common:labels:confirm'),
        isLoading: loading,
        disabled: loading,
        onClick: () => {
          updateBrokerLicenseStatus({
            variables: {
              brokerId,
              input: {
                reason: '',
                status: BrokerLicenseStatusesEnum.Active,
              },
            },
            onCompleted: () => {
              toast.success(
                t(`pages:brokersPage:modals:activateBrokerLicenseSuccess`)
              );
              onClose();
            },
            onError: (error) => {
              toast.error(translateServerResponse(error));
            },
          });
        },
      }}
    >
      <Text>{t(`pages:brokersPage:modals:activateBrokerLicenseSubTitle`)}</Text>
    </Modal>
  );
};

export default ActivateBrokerLicenseModal;
